import { CalendarIcon, MailIcon } from 'lucide-react';

import { initialsOf } from './account-manager-helper';

/** The person at Commenda who owns the account, shown when the user asks who to talk to or when
 * they need a human — pricing, a purchase, or something chat cannot do. Mirrors
 * {@link AttachmentCard}'s geometry so both cards sit flush in a message. */
interface AccountManagerCardProps {
  name: string | null;
  email: string;
  bookingLink: string | null;
  role?: string;
}

export function AccountManagerCard({
  name,
  email,
  bookingLink,
  role = 'Customer success manager',
}: Readonly<AccountManagerCardProps>) {
  return (
    <div className="flex w-full items-center gap-lg rounded-lg border-[0.5px] border-border-primary bg-bg-primary p-xl shadow-[0px_2px_4px_0px_rgba(0,0,0,0.04)]">
      <span className="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-bg-secondary txt-small-medium text-text-secondary">
        {initialsOf(name, email)}
      </span>

      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate txt-small-medium text-text-primary">
          {name ?? email}
        </span>
        <span className="txt-extra-small-regular text-text-secondary">
          {role}
        </span>
      </div>

      <div className="flex shrink-0 items-center gap-md">
        <a
          href={`mailto:${email}`}
          aria-label={`Email ${name ?? email}`}
          className="flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-sm border-[0.5px] border-border-primary bg-bg-primary text-fg-tertiary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] transition-colors hover:text-text-primary"
        >
          <MailIcon className="size-4" />
        </a>
        {bookingLink ? (
          <a
            href={bookingLink}
            target="_blank"
            rel="noreferrer"
            className="flex shrink-0 cursor-pointer items-center gap-sm rounded-sm border-[0.5px] border-border-primary bg-bg-primary px-md py-sm txt-small-medium text-text-secondary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] transition-colors hover:text-text-primary"
          >
            <CalendarIcon className="size-4" />
            Book a call
          </a>
        ) : (
          <a
            href={`mailto:${email}`}
            className="flex shrink-0 cursor-pointer items-center justify-center rounded-sm border-[0.5px] border-border-primary bg-bg-primary px-md py-sm txt-small-medium text-text-secondary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] transition-colors hover:text-text-primary"
          >
            Email
          </a>
        )}
      </div>
    </div>
  );
}
